import { AfterContentInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[appFocus]',
})
// todo: make all name equal!
export class FocusDirective implements AfterContentInit {
    @Input() appAutoFocus = false;
    @Input() focusTimeout = 0;
    @Input() focusableSelectElement?;

    constructor(private el: ElementRef) {}

    ngAfterContentInit() {
        if (this.appAutoFocus) {
            setTimeout(() => {
                if (this.focusableSelectElement) {
                    this.focusableSelectElement.focus();
                } else {
                    this.el.nativeElement.focus();
                }
            }, this.focusTimeout);
        }
    }
}
